var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',{attrs:{"title":"创建金融单","left-arrow":""}},[_c('FinancialOrder',{ref:"financialOrder",attrs:{"orderNum":_vm.orderNum}}),_c('Footer',{attrs:{"slot":"footer"},on:{"on-save":_vm.onSave,"on-cancel":function($event){return _vm.$page.close()}},slot:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }